export const initImpressionsSlider = () => {
  const slider = document.querySelector('[data-impressions-slider]');
  if (!slider) {
    return;
  }
  const mediaQuery = window.matchMedia('(max-width: 768px)');
  let swiper = null;
  const enableSwiper = () => {
    if (swiper) {
      return;
    }
    swiper = new Swiper(slider, {
      spaceBetween: 20,
      slidesPerView: 1.1,
      breakpoints: {
        // 391: {
        //   slidesPerView: 1.5,
        // },
        577: {
          slidesPerView: 1.4,
        },
        769: {
          slidesPerView: 2.1,
        },
      },
    });
  };
  const destroySwiper = () => {
    if (swiper) {
      swiper.destroy(true, true);
      swiper = null;
    }
  };
  const checkMedia = () => {
    if (mediaQuery.matches) {
      enableSwiper();
    } else {
      destroySwiper();
    }
  };
  checkMedia();
  mediaQuery.addEventListener('change', checkMedia);
};
